import {
  ROOT,
  UPLOAD_CERTIFICATE,
  UPLOAD_IMAGE_RESOURCE,
  DELETE_IMAGE_RESOURCE
} from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";

// const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
// const authHeader = currentUser.token
//   ? { Authorization: "Token " + currentUser.token }
//   : {};

function uploadCetificate(data) {
  let justRegisted = JSON.parse(localStorage.getItem("justRegistedUser"));
  let username = justRegisted.username;
  let token = justRegisted.token;
  return fetch(ROOT + UPLOAD_CERTIFICATE, {
    method: "POST",
    body: data,
    headers: {
      token: token,
      username: username
    }
  })
    .then(handleResponse)
    .then(data => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      return data;
    });
}
function uploadImage(data) {
  let currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  let authHeader = currentUser.token ? { Authorization: "Token " + currentUser.token } : {};
  return fetch(ROOT + UPLOAD_IMAGE_RESOURCE, {
    method: "POST",
    body: data,
    headers: {
      Authorization: authHeader.Authorization
    }
  })
    .then(handleResponse)
    .then(data => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      return data;
    });
}
function remove(id) {
  return fetch(ROOT + DELETE_IMAGE_RESOURCE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      return data;
    });
}
export const service = {
  uploadCetificate,
  uploadImage,
  remove
};
